import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebaseConfig';

export const PUBLIC_AUTH_PATHS = new Set([
  '/',
  '/login',
  '/register',
  '/verify-email',
  '/verify-phone',
  '/verify-id',
  '/verify-review',
  '/download',
  '/privacy-policy',
  '/terms',
]);

const PENDING_NOTIFICATION_REDIRECT_KEY = 'pendingNotificationRedirect';
export const PENDING_NOTIFICATION_REDIRECT_TTL_MS = 10 * 60 * 1000;

export function isPublicAuthPath(path) {
  return PUBLIC_AUTH_PATHS.has(path);
}

export async function loadUserProfile(uid) {
  if (!uid) return null;
  const snap = await getDoc(doc(db, 'users', uid));
  if (!snap.exists()) return null;
  return snap.data();
}

export function persistCurrentUserProfile(uid, profileData) {
  if (!uid || !profileData) return;
  localStorage.setItem(
    'currentUserProfile',
    JSON.stringify({ ...profileData, uid })
  );
}

export function clearCurrentUserProfile() {
  localStorage.removeItem('currentUserProfile');
}

export function isValidPendingNotificationRoute(route) {
  return (
    typeof route === 'string' &&
    (
      route.startsWith('/direct/') ||
      route.startsWith('/group/') ||
      route === '/messages' ||
      route === '/intel'
    )
  );
}

export function setPendingNotificationRedirect(route, uid = null) {
  if (!isValidPendingNotificationRoute(route)) return;
  const payload = {
    route,
    createdAt: Date.now(),
  };
  if (uid) {
    payload.uid = uid;
  }
  localStorage.setItem(
    PENDING_NOTIFICATION_REDIRECT_KEY,
    JSON.stringify(payload)
  );
}

export function getPendingNotificationRedirect(uid = null) {
  try {
    const payload = JSON.parse(
      localStorage.getItem(PENDING_NOTIFICATION_REDIRECT_KEY) || 'null'
    );
    if (!payload || typeof payload !== 'object') return null;
    if (uid && payload.uid && payload.uid !== uid) return null;
    if (!isValidPendingNotificationRoute(payload.route)) return null;
    return payload;
  } catch (_) {
    return null;
  }
}

export function isFreshPendingNotificationRedirect(pendingRedirect) {
  const route = pendingRedirect?.route;
  const createdAt = pendingRedirect?.createdAt;
  return (
    isValidPendingNotificationRoute(route) &&
    typeof createdAt === 'number' &&
    Date.now() - createdAt <= PENDING_NOTIFICATION_REDIRECT_TTL_MS
  );
}

export function clearPendingNotificationRedirect() {
  localStorage.removeItem(PENDING_NOTIFICATION_REDIRECT_KEY);
}

export function getPostVerificationRoute(user, profileData) {
  if (!user?.emailVerified) return '/verify-email';
  if (profileData?.phoneVerified !== true) return '/verify-phone';
  const vs = profileData?.verificationStatus;
  if (!vs || vs !== 'approved') return '/verify-review';
  if (profileData?.accountSuspended) return '/my-account';
  return '/messages';
}
